import { options_connected_full_failedStatus } from './resetConnectedFullStore.locstring.json';
import loc from 'owa-localize';
import MrsConnectedAccountsInformation from 'owa-service/lib/contract/MrsConnectedAccountsInformation';
import { connectedAccountsStore } from '../../store/store';
import { mutatorAction } from 'satcheljs';

export let resetConnectedFullStore = mutatorAction(
    'resetConnectedFullStore',
    (accountsInfo: MrsConnectedAccountsInformation) => {
        let store = connectedAccountsStore();
        store.accounts = [];
        store.selected = -1;
        store.accountsInfo = accountsInfo;

        if (accountsInfo) {
            for (let request of accountsInfo.SyncRequests) {
                let lastUpdate = request.LastUpdateTimestamp;

                if (request.Status === 'Failed' || request.Status === 'Suspended') {
                    lastUpdate = loc(options_connected_full_failedStatus);
                }

                store.accounts.push({
                    accountName: request.EmailAddress,
                    status: request.Status,
                    lastUpdate: lastUpdate,
                    syncRequest: request,
                });
            }
        }
    }
);
